import type { PasteOptionsToolbarPluginConfiguration } from '@atlaskit/editor-plugin-paste-options-toolbar/paste-options-toolbar-plugin-type';
import { convertMarkdownToProsemirror } from '@atlassian/ai-model-io/convert-markdown-to-prosemirror';

interface Props {
	options: PasteOptionsToolbarPluginConfiguration | undefined;
	usePopupBasedPasteActionsMenuDefault: boolean | undefined;
}

/**
 * Builds paste-options-toolbar plugin options for Confluence full-page preset.
 * Injects markdown-plus converter while preserving any caller-provided override.
 */
export function pasteOptionsToolbarPluginOptions({
	options,
	usePopupBasedPasteActionsMenuDefault,
}: Props): PasteOptionsToolbarPluginConfiguration {
	const markdownToPmConverter =
		options?.markdownToPmConverter ??
		(({ markdown, schema }) =>
			convertMarkdownToProsemirror({
				schema,
				markdown,
				idMap: {},
				featureToggles: {
					markdownPlus: true,
					markdownPlusRemoveUnclosedTokens: true,
				},
			}).pmFragment);

	return {
		markdownToPmConverter,
		pasteMenuButtonsFactory: options?.pasteMenuButtonsFactory,
		usePopupBasedPasteActionsMenu:
			options?.usePopupBasedPasteActionsMenu ?? usePopupBasedPasteActionsMenuDefault,
	};
}
